import React, { useState, useEffect } from 'react'
import MaterialTable from '@material-table/core'
import { Button, IconButton } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import VisibilityIcon from '@material-ui/icons/Visibility'
import ClearIcon from '@material-ui/icons/Clear';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getPayments, postPaymentStatus } from '@auteco/services/luciaPaymentsService'
import { dateToLocal } from '@auteco/utils/dateToLocal'
import { Alert } from '../Alert'
import { useStyles } from './styles'
import { DialogFiles } from '../DialogFiles'
import { DialogChasis } from '../DialogChasis'

const initialAlert = {
    open: false,
    onClose: () => { },
    title: '',
    content: '',
    onlyButton: false,
    btn1Txt: '',
    btn2Txt: '',
    btn1Func: () => { },
    btn2Func: () => { }
}

const initialDialogFiles = {
    xml: null,
    html: null,
    state: false,
    open: false,
    onClose: () => { }
}

const initialDialogChasis = {
    chasis: null,
    open: false,
    onClose: () => { }
}

const PaymentsTable = () => {
    const [alertInfo, setAlertInfo] = useState(initialAlert)
    const [payments, setPayments] = useState([])
    const [dialogFiles, setDialogFiles] = useState(initialDialogFiles)
    const [dialogChasis, setDialogChasis] = useState(initialDialogChasis)

    const classes = useStyles()

    const getPaymentsInfo = async () => {
        const { facturas } = await getPayments()
        if (facturas) {
            setPayments(facturas)
        }
    }

    const formatBoolean = ({ value }) => value ? 'Válido' : 'Inconsistente'

    const formatBooleanShort = ({ value }) => value ? 'Sí' : 'No'

    const updateStatus = async ({ payment, status }) => {
        const body = {
            validacion_id: payment.validacion_id,
            chasis: payment.chasis,
            valido: status,
            nit: payment.xml.emisor.nit,
            razon_social: payment.xml.emisor.nombre,
            valor_reconocer: Number(payment.datos_chasis.VALOR_RECONOCER)
        }
        const { success } = await postPaymentStatus({ params: body })
        if (success === 1) {
            getPaymentsInfo()
            setAlertInfo(initialAlert)
        }
    }

    const onCloseAlert = () => {
        setAlertInfo(initialAlert)
    }

    const onCloseViewFiles = () => {
        setDialogFiles(initialDialogFiles)
    }

    const onCloseViewChasis = () => {
        setDialogChasis(initialDialogChasis)
    }

    const onViewFiles = ({ payment }) => {
        setDialogFiles({ xml: payment.xml, html: payment.html, state: payment.comparacion, open: true, onClose: onCloseViewFiles })
    }

    const onViewChasis = ({ chasis }) => {
        setDialogChasis({ chasis, open: true, onClose: onCloseViewChasis })
    }

    const onAcceptPayment = ({ payment }) => {
        setAlertInfo({ open: true, onClose: onCloseAlert, title: '¡Espera!', content: 'Estás a punto de aprobar este pago, ¿deseas continuar?', btn1Txt: 'Aceptar', btn2Txt: 'Cancelar', btn1Func: () => updateStatus({ payment, status: true }), btn2Func: onCloseAlert })
    }

    const onDeclinePayment = ({ payment }) => {
        setAlertInfo({ open: true, onClose: onCloseAlert, title: '¡Espera!', content: 'Estás a punto de rechazar este pago, ¿deseas continuar?', btn1Txt: 'Aceptar', btn2Txt: 'Cancelar', btn1Func: () => updateStatus({ payment, status: false }), btn2Func: onCloseAlert })
    }

    const downloadFile = ({ url }) => {
        window.open(url, '_blank');
    }

    const columns = [
        {
            title: 'Chasis',
            field: 'chasis'
        },
        {
            title: 'Razón social',
            field: 'nit'
        },
        {
            title: 'Fecha ingreso',
            field: 'creacion',
            render: (rowData) => dateToLocal(rowData.creacion).formattedDateAndHour
        },
        {
            title: 'Validación maquina',
            field: 'comparacion',
            render: (rowData) => <Button className={classes.stateButton} onClick={() => onViewFiles({ payment: rowData })}>{formatBoolean({ value: rowData.comparacion })}</Button>
        },
        {
            title: 'Validación manual',
            field: 'comparacion_manual',
            render: (rowData) => rowData.comparacion_manual === null ? 'Pendiente' : formatBoolean({ value: rowData.comparacion_manual })
        },
        {
            title: 'Línea',
            field: 'datos_chasis.Texto_breve_de_material',
        },
        {
            title: 'Datos chasis',
            field: 'datos_chasis',
            render: (rowData) => (
                <div>
                    {
                        Object.keys(rowData.datos_chasis).length !== 0 ?
                            <div style={{ width: '140px' }}>
                                <p>Válido: {formatBooleanShort({ value: rowData.datos_chasis.VALIDO })}</p>
                                <p>Valor a reconocer: {Number(rowData.datos_chasis.VALOR_RECONOCER).toLocaleString('es-ES')}</p>
                                <p>Descuento aplicado: {Number(rowData.datos_chasis.DIFERENCIA_MARGENES).toLocaleString('es-ES')}</p>
                            </div>
                            :
                            <p>No hay datos disponibles</p>
                    }
                </div>
            )
        },
        {
            title: 'Accionesx',
            render: (rowData) => (
                <div style={{ width: '200px' }}>
                    <IconButton
                        className={classes.iconButton}
                        disabled={Object.keys(rowData.datos_chasis).length === 0}
                        onClick={() => onViewChasis({ chasis: rowData.datos_chasis })}>
                        <VisibilityIcon />
                    </IconButton>
                    <IconButton
                        className={classes.iconButton}
                        disabled={Object.keys(rowData.datos_chasis).length === 0}
                        onClick={() => downloadFile({ url: rowData.url })}
                    >
                        <GetAppIcon />
                    </IconButton>
                    <IconButton
                        className={classes.iconButton}
                        disabled={Object.keys(rowData.datos_chasis).length === 0}
                        onClick={() => onAcceptPayment({ payment: rowData })}
                    >
                        <CheckIcon />
                    </IconButton>
                    <IconButton
                        className={classes.iconButton}
                        disabled={Object.keys(rowData.datos_chasis).length === 0}
                        onClick={() => onDeclinePayment({ payment: rowData })}
                    >
                        <ClearIcon />
                    </IconButton>
                </div>
            )
        }
    ]

    useEffect(() => {
        getPaymentsInfo()
    }, [])
    return (
        <>
            <Alert
                info={alertInfo}
            />
            <DialogFiles info={dialogFiles} />
            <DialogChasis info={dialogChasis} />
            < MaterialTable
                data={payments}
                columns={columns}
                title=''
                options={{
                    headerStyle: {
                        backgroundColor: '#35465c',
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: 700,
                    },
                }}
            />
        </>
    )
}

export { PaymentsTable }